// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip-full-width .tooltip-inner {\n  max-width: -moz-max-content !important;\n  max-width: max-content !important;\n  word-break: break-all;\n}", ""]);
// Exports
module.exports = exports;
